const dataTableData = {
  columns: [
    { Header: "#", accessor: "#", width: "5%" },
    { Header: "ID", accessor: "id", width: "5%" },
    { Header: "Name", accessor: "displayName", width: "15%" },
    { Header: "userName", accessor: "userName", width: "15%" },
    { Header: "email", accessor: "email", width: "10%" },

    { Header: "Actions", accessor: "actions", width: "10%" },
  ],

  rows: [], // Populate this with data from your API or DTOs as required
};

export default dataTableData;
